// extracted by mini-css-extract-plugin
export default {"root":"MaterialSymbol_root__6hopY"};